import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SkillMeter from './SkillMeter';
import type { Skill } from '../types';

interface SkillsSectionProps {
  skills: Skill[];
}

const SkillsSection = ({ skills }: SkillsSectionProps) => {
  const { t } = useTranslation();
  const categories = Array.from(new Set(skills.map(skill => skill.category)));

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="max-w-6xl mx-auto mb-16"
    >
      <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
        {t('about.sections.skills')}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {categories.map((category, categoryIndex) => (
          <div
            key={category}
            className="glass-card rounded-2xl p-8"
          >
            <h3 className="text-xl font-semibold text-accent mb-6">{category}</h3>
            {skills
              .filter(skill => skill.category === category)
              .map((skill, skillIndex) => (
                <SkillMeter
                  key={skill.name}
                  skill={skill}
                  index={categoryIndex * 3 + skillIndex}
                />
              ))}
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default SkillsSection;